import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Program from './Program'
import './styles.scss'

const ProgramsGrid = props => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [programsList, setProgramsList] = useState(props.programs)
  const [activeCategory, setActiveCategory] = useState(0)

  //load post with new active category
  useEffect(() => {
    setIsLoaded(true)
  }, [])

  useEffect(() => {
    setProgramsList(programsList)
  }, [activeCategory])

  return (
    <div className={`dhsv_listblock_programs_grid`}>
      <div className="row">
        <div className="col-lg-12">
          {props.title && (
            <h4
              className={'cats-title'}
              dangerouslySetInnerHTML={{
                __html: props.title,
              }}
            />
          )}
          {props.categories && (
            <div className={'programs-cats'}>
              {props.categories.map(category => (
                <span
                  className={category.colorClass}
                  key={category.term_id}
                  {...(category.term_id === activeCategory && {
                    className: 'active ' + category.colorClass,
                  })}
                  onClick={() =>
                    setActiveCategory(
                      category.term_id === activeCategory ? 0 : category.term_id
                    )
                  }
                >
                  {console.log(category)}
                  {category.name}
                </span>
              ))}
            </div>
          )}
        </div>
        <div className="col-lg-12">
          {isLoaded && programsList.length ? (
            <div className={'programs-grid'}>
              {programsList
                .filter(
                  post =>
                    post.kategorien.find(o => o.term_id === activeCategory) ||
                    !activeCategory
                )
                .map(post => (
                  <Program key={post.id} post={post} link={props.link_title} />
                ))}
            </div>
          ) : (
            '...'
          )}
        </div>
      </div>
    </div>
  )
}

ProgramsGrid.propTypes = {
  anchor: PropTypes.string,
  title: PropTypes.string,
  link_title: PropTypes.string,
  categories: PropTypes.array.isRequired,
  programs: PropTypes.array.isRequired,
}

export default ProgramsGrid
